module.exports = __webpack_public_path__ + "img/iphone-mockup-3.32936886.png";